import { Controller } from "stimulus";
import React from "react";
import ReactDOM from "react-dom";
import ProductModal from "~/scripts/components/ProductModal";

const CLASS_BODY_DISABLED = "is-scroll-disabled";

export default class extends Controller {
    static targets = ["root"];

    connect() {
        this.render(false);
    }

    open(event) {
        this.selected = window.variations[event.target.dataset.id];

        document.body.classList.add(CLASS_BODY_DISABLED);

        this.render(true);
    }

    handleCrossClick = () => {
        this.close();
    };

    close() {
        document.body.classList.remove(CLASS_BODY_DISABLED);

        this.render(false);
    }

    render(active) {
        ReactDOM.render(
            <ProductModal
                active={active}
                onCrossClick={this.handleCrossClick}
                familyDownloads={window.familyDownloads}
                {...this.selected}
            />,
            this.rootTarget
        );
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/modal_controller.js